var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.57007 18.0703L3.50007 12.0003L9.57007 5.93031","stroke":"#EEEEEE","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20.5 12H3.67","stroke":"#EEEEEE","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
